import React from 'react';

import { ButtonProps } from '@/components/shadcn/ui/button';
import { ConnectedTronWallet } from '@/networks/tron';

const HeaderWalletDrawerTronWalletConnect: React.FC<ButtonProps> = (props) => {
  return <ConnectedTronWallet {...props} />;
};

export default HeaderWalletDrawerTronWalletConnect;
